// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__qSYy9","footer":"ModalInfo_footer__3SHZw"};